import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { LucideProps } from 'lucide-react'

export interface AnimatedBotProps extends LucideProps {
  animateOnHover?: boolean
}

export function AnimatedBot({
  size = 20,
  className = '',
  animateOnHover = true,
  ...props
}: AnimatedBotProps) {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <motion.div
      className={`inline-flex items-center justify-center ${className}`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      animate={
        isHovered && animateOnHover
          ? { scale: [1, 1.12, 1], rotate: [0, -6, 6, -3, 3, 0] }
          : { scale: 1, rotate: 0 }
      }
      transition={{ duration: 0.45, ease: 'easeInOut' }}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        {...(props as React.SVGProps<SVGSVGElement>)}
      >
        {/* Antenna */}
        <motion.path
          d="M12 8V4H8"
          animate={
            isHovered && animateOnHover
              ? { rotate: [-8, 8, -4, 4, 0], originX: '12px', originY: '8px' }
              : {}
          }
          transition={{ duration: 0.4 }}
        />
        {/* Head Base */}
        <rect width="16" height="12" x="4" y="8" rx="2" />
        {/* Ears */}
        <path d="M2 14h2" />
        <path d="M20 14h2" />
        {/* Left Eye */}
        <motion.path
          d="M9 13v2"
          animate={isHovered && animateOnHover ? { scaleY: [1, 0.1, 1] } : {}}
          transition={{ duration: 0.3, repeat: 1 }}
        />
        {/* Right Eye */}
        <motion.path
          d="M15 13v2"
          animate={isHovered && animateOnHover ? { scaleY: [1, 0.1, 1] } : {}}
          transition={{ duration: 0.3, repeat: 1 }}
        />
      </svg>
    </motion.div>
  )
}

export function AnimateIcon({
  children,
  animateOnHover = true,
  className = '',
}: {
  children: React.ReactNode
  animateOnHover?: boolean
  className?: string
}) {
  return (
    <motion.div
      className={`inline-flex items-center justify-center ${className}`}
      whileHover={
        animateOnHover
          ? {
              scale: 1.15,
              rotate: [0, -6, 6, -3, 3, 0],
              transition: { duration: 0.45, ease: 'easeInOut' },
            }
          : undefined
      }
    >
      {children}
    </motion.div>
  )
}

export default AnimatedBot
